import { StateCustomDataConstants } from './nemsisCustomData.constants'
import { IStateCustomDataDisplayState, IStateCustomElementsAction } from './nemsisCustomData.types'

export const initialCustomDisplayDataState: IStateCustomDataDisplayState = {
  stateCustomElements: [],
  customElementId: null,
  state: '',
  groupId: null,
  groupKey: '',
  groupingSequence: null,
  customElementSequence: null,
  customElementValue: null,
  customElementPNNVValue: null,
  customElementMultiInstancePNNVValue: null,
  updateAction: '',
  _pnnvToggle: false,
  customOption: null,
}

export function stateCustomDisplayData(
  state: IStateCustomDataDisplayState = initialCustomDisplayDataState,
  action: IStateCustomElementsAction
): IStateCustomDataDisplayState {
  switch (action.type) {
    case StateCustomDataConstants.SET_STATE_CUSTOM_DISPLAY_DATA:
      return { ...state, stateCustomElements: action.stateCustomElements }
    case StateCustomDataConstants.SET_STATE_CUSTOM_ELEMENT_VALUE:
      return {
        ...state,
        ...(action.additionalData && {
          customElementValue: action.customElementValue,
          customElementId: action.additionalData?.customElementId,
          groupId: action.additionalData?.groupId,
          groupingSequence: action.additionalData?.groupingSequence,
          key: action.additionalData?.key,
          groupKey: action.additionalData?.groupKey,
        }),
      }
    case StateCustomDataConstants.SET_STATE_CUSTOM_ELEMENT_PNNV_VALUE:
      return {
        ...state,
        ...(action.additionalData && {
          customElementPNNVValue: action.customElementPNNVValue,
          customElementId: action.additionalData?.customElementId,
          groupId: action.additionalData?.groupId,
          groupingSequence: action.additionalData?.groupingSequence,
          key: action.additionalData?.key,
          groupKey: action.additionalData?.groupKey,
        }),
      }
    case StateCustomDataConstants.SET_STATE_MULTI_INSTANCE_CUSTOM_ELEMENT_PNNV_VALUE:
      return {
        ...state,
        ...(action.additionalData && {
          customElementMultiInstancePNNVValue: action.customElementMultiInstancePNNVValue,
          customElementId: action.additionalData?.customElementId,
          groupId: action.additionalData?.groupId,
          groupingSequence: action.additionalData?.groupingSequence,
          key: action.additionalData?.key,
          groupKey: action.additionalData?.groupKey,
        }),
      }
    case StateCustomDataConstants.DUPLICATE_GROUP:
      return {
        ...state,
        state: action.state,
        groupId: action.groupId,
        groupKey: action.groupKey,
      }
    case StateCustomDataConstants.UPDATE_GROUPS_FROM_TIMELINE:
      return {
        ...state,
        updateAction: action.updateAction,
        deleteMedicationKey: action.deleteMedicationKey,
      }
    case StateCustomDataConstants.DELETE_CUSTOM_ELEMENT_GROUP:
      return {
        ...state,
        state: action.state,
        groupId: action.groupId,
        groupingSequence: action.groupingSequence,
        groupKey: action.groupKey,
      }
    case StateCustomDataConstants.DUPLICATE_CUSTOM_ELEMENT:
      return {
        ...state,
        state: action.state,
        groupId: action.groupId,
        customElementId: action.customElementId,
        groupKey: action.groupKey,
        groupingSequence: action.groupingSequence,
        key: action.key,
      }
    case StateCustomDataConstants.DELETE_CUSTOM_ELEMENT:
      return {
        ...state,
        state: action.state,
        groupId: action.groupId,
        groupingSequence: action.groupingSequence,
        groupKey: action.groupKey,
        customElementId: action.customElementId,
        key: action.key,
      }
    case StateCustomDataConstants.SET_PNNV_TOGGLE:
      return {
        ...state,
        ...(action.additionalData && {
          _pnnvToggle: action._pnnvToggle,
          customElementId: action.additionalData?.customElementId,
          groupId: action.additionalData?.groupId,
          groupingSequence: action.additionalData?.groupingSequence,
          key: action.additionalData?.key,
          groupKey: action.additionalData?.groupKey,
        }),
      }
    case StateCustomDataConstants.RESET_NEMSIS_CUSTOM_DATA:
      return { ...initialCustomDisplayDataState }
    default:
      return state
  }
}
